import styled from 'styled-components';
import { ButtonTag } from '../Button/styles';

export const AlsoBoughtSection = styled.section`
`;

export const AlsoBoughtContainer = styled.div`
  padding: 0 25px;
  
  @media(min-width: 768px) {
    padding: 0 40px;
  }
  
  @media(min-width: 1024px) {
    padding: 0;
  }
`;

export const AlsoBoughtHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
  
  @media(min-width: 768px) {
    margin-bottom: 35px;
  }
  
  @media(min-width: 1024px) {
    margin-bottom: 25px;
  }
`;

export const AlsoBoughtHeading = styled.h2`
  margin: 0;
  padding: 0;
  
  font-size: 18px;
  line-height: 1;
  
  @media(min-width: 768px) {
    font-size: 24px;
  }
`;

export const AlsoBoughtButton = styled(ButtonTag)`
  width: 100%;
  
  svg {
    margin-left: 10px;
  }
  
  @media(min-width: 768px) {
    width: auto;
    padding: 20px 80px;
  }
`;

export const AlsoBoughtSlider = styled.div`
  margin-bottom: 40px;
  margin-right: -25px;
  
  @media(min-width: 768px) {
    margin-right: 0;
    
    .swiper-wrapper {
      transform: none !important;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 30px;
      grid-row-gap: 15px;
    }
  }
  
  @media(min-width: 1024px) {
    margin-bottom: 0;
  }
`;

export const AlsoBoughtSlide = styled.div`
  max-width: 240px;
  
  a {
    display: inline-block;
  }
  
  @media(min-width: 768px) {
    max-width: none;
    margin-right: 0 !important;
  }
`;
